import React, { memo, useCallback, useEffect, useState, VFC } from "react";
import { Flex, Spacer, Text, Box, Button } from "@chakra-ui/react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { BsBook } from "react-icons/bs";
import { useNavigate, useLocation } from "react-router-dom";
import { menuArray } from "../../router/Menu";
import { DocDialog } from "../organisms/modal/DocDialog";
import { DrawerMenu } from "../molecules/DrawerMenu";
import { LogoutButton } from "../atoms/button/LogoutButton";
import { useLoginUser } from "../../hooks/providers/useLoginUserProvider";
import { Menu } from "../../types/menu";

export const Header: VFC = memo(() => {
  const { loginUser } = useLoginUser();
  const [ link, setLink ] = useState("");
  const [ docFlag, setDocFlag ] = useState(false);
  const appType = process.env.REACT_APP_APP_TYPE;

  const [ headerColor ] = useState(
    loginUser.envType === "DEV" ? "gray.500" :
    loginUser.envType === "STG" ? "teal.500" : "blue.500"
  );
  
  const [ envName ] = useState(
    loginUser.envType === "DEV" ?  "（開発）" :
    loginUser.envType === "STG" ?  "（ステージング）" : ""
  );
  
  const [ UserKindHash ] = useState<{ [key: string]: string }>({
    'nec':      'NECグループ担当者',
    'customer': 'お客様',
    'deskadmin':'デスク管理者',
    'desk':     'デスク担当者',
    'basedon':  'BasedOn担当者',
    'exec':     '事業責任者',
    'nes':      'NES担当者',
    'nexs':     'NEXS担当者',
  });
  
  const navigate = useNavigate();
  const location = useLocation();
  
  // リロード時にloginUser情報がクリアされる場合の対策
  useEffect(() => {
    if( !loginUser.email ) navigate("/");
  }, [loginUser]);
  
  const onClickHome = useCallback(() => {
    navigate("/reloadURL?url=/home")
  }, [navigate]);
  
  useEffect(() => {
    setLink(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Flex
        as="nav"
        bg={headerColor}
        color="gray.50"
        align="center"
        justify="space-between"
        padding={{ base: 3 }}
      >
        <Box display={{ base: "block", md: "none" }}> {/* for mobile */}
          <DrawerMenu />
        </Box>
        <Flex
          align="center"
          fontSize="sm"
          display={{ base: "flex" }}
          flexGrow={1}
        >
          <Breadcrumb>
            <BreadcrumbItem>
              <BreadcrumbLink onClick={onClickHome}>{"マルチクラウド障害通知システム" + (appType === 'ADMIN' ? '（主管向け）' : '') + envName}</BreadcrumbLink>
            </BreadcrumbItem>
            {menuArray.map((groups: Menu[]) => {
              //const link: string = `${location.pathname}${location.search}`;
              return groups.map((obj: Menu) => {
                //console.log(link,obj.link,obj.name);
                return (
                  link === obj.link && (
                    <BreadcrumbItem isCurrentPage key={obj.link}>
                      <BreadcrumbLink>{obj.name}</BreadcrumbLink>
                    </BreadcrumbItem>
                  )
                );
              });
            })}
          </Breadcrumb>
        </Flex>
        <Spacer />
        <Flex pr={2}>
          <Text fontSize="xs">{!loginUser.username.indexOf('nec-authentication') ? loginUser.email : loginUser.username}さん{loginUser.userGroup && '（'+UserKindHash[loginUser.userGroup]+'）'}</Text>
        </Flex>
        <Button
          id="doc"
          bg="blue.400"
          color="white"
          size="xs"
          _hover={{ opacity: 0.8 }}
          onClick={()=>setDocFlag(true)}
          rightIcon={<BsBook />}
          marginRight="8px"
        >
          ドキュメント
        </Button>
        <LogoutButton btnName="ログアウト" />
      </Flex>
      {docFlag && <DocDialog setDocFlag={setDocFlag} />}
    </>
  );
  
});